import { render, staticRenderFns } from "./EditParticipantsDetails.vue?vue&type=template&id=ee670c16"
import script from "./EditParticipantsDetails.vue?vue&type=script&lang=js"
export * from "./EditParticipantsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports